import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function Layout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="app">
            <header style={{
                background: 'var(--color-surface)',
                borderBottom: '1px solid var(--color-border)',
                padding: '1rem 2rem',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <span style={{ fontSize: '1.5rem' }}>⚗️</span>
                    <h1 style={{ fontSize: '1.25rem', fontWeight: 600 }}>
                        The Alchemist
                    </h1>
                </div>

                <nav style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    <NavLink
                        to="/"
                        style={({ isActive }) => ({
                            color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                            textDecoration: 'none',
                            padding: '0.5rem 1rem',
                            borderRadius: '6px',
                            transition: 'all 0.2s'
                        })}
                    >
                        優化提案
                    </NavLink>
                    <NavLink
                        to="/optimizer"
                        style={({ isActive }) => ({
                            color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                            textDecoration: 'none',
                            padding: '0.5rem 1rem',
                            borderRadius: '6px',
                            transition: 'all 0.2s'
                        })}
                    >
                        ✨ 自選優化
                    </NavLink>
                    <NavLink
                        to="/ad-creator"
                        style={({ isActive }) => ({
                            color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                            textDecoration: 'none',
                            padding: '0.5rem 1rem',
                            borderRadius: '6px',
                            transition: 'all 0.2s'
                        })}
                    >
                        🚀 廣告建立器
                    </NavLink>
                    <NavLink
                        to="/batch-creator"
                        style={({ isActive }) => ({
                            color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                            textDecoration: 'none',
                            padding: '0.5rem 1rem',
                            borderRadius: '6px',
                            transition: 'all 0.2s'
                        })}
                    >
                        📦 批量生成
                    </NavLink>
                    <NavLink
                        to="/copy-pattern-efficiency"
                        style={({ isActive }) => ({
                            color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                            textDecoration: 'none',
                            padding: '0.5rem 1rem',
                            borderRadius: '6px',
                            transition: 'all 0.2s'
                        })}
                    >
                        🧪 低效文案模式
                    </NavLink>
                    <NavLink
                        to="/copy-history"
                        style={({ isActive }) => ({
                            color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                            textDecoration: 'none',
                            padding: '0.5rem 1rem',
                            borderRadius: '6px',
                            transition: 'all 0.2s'
                        })}
                    >
                        📚 文案歷史
                    </NavLink>
                    <NavLink
                        to="/history"
                        style={({ isActive }) => ({
                            color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                            textDecoration: 'none',
                            padding: '0.5rem 1rem',
                            borderRadius: '6px',
                            transition: 'all 0.2s'
                        })}
                    >
                        部署歷史
                    </NavLink>
                    <NavLink
                        to="/settings"
                        style={({ isActive }) => ({
                            color: isActive ? 'var(--color-primary)' : 'var(--color-text-secondary)',
                            textDecoration: 'none',
                            padding: '0.5rem 1rem',
                            borderRadius: '6px',
                            transition: 'all 0.2s'
                        })}
                    >
                        品牌資料庫
                    </NavLink>
                    
                    <div style={{
                        marginLeft: '1rem',
                        paddingLeft: '1rem',
                        borderLeft: '1px solid var(--color-border)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.75rem'
                    }}>
                        <span style={{
                            fontSize: '0.85rem',
                            color: 'var(--color-text-secondary)'
                        }}>
                            {user?.email}
                        </span>
                        <button
                            onClick={handleLogout}
                            style={{
                                padding: '0.5rem 1rem',
                                background: 'var(--color-danger)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: '0.85rem',
                                fontWeight: 500,
                                transition: 'all 0.2s'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.opacity = '0.9'}
                            onMouseOut={(e) => e.currentTarget.style.opacity = '1'}
                        >
                            登出
                        </button>
                    </div>
                </nav>
            </header>

            <main className="container">
                <Outlet />
            </main>
        </div>
    );
}
